export default __webpack_public_path__ + "static/media/image-4.73b63487.png";